import { httpClient } from "../http/httpClient"

export interface IEducationLevel {
  escolaridadeId: number
  descricao: string
}

export interface IBank {
  codigoBanco: number
  descricao: string
}

export interface IMaritalStatus {
  estadoCivilId: number
  descricao: string
}

export interface IOrgans {
  sigla: string
  descricao: string
}
export interface GetComplementsResponse {
  escolaridade: IEducationLevel[]
  bancosConveniados: IBank[]
  estadoCivil: IMaritalStatus[]
  orgaoEmissorRg: IOrgans[]
}
export async function getComplements() {
  const response = await httpClient
    .get<GetComplementsResponse>(`/crefisa/complements`)
    .catch((error) => {
      throw error.response?.data || error
    })
  return response.data
}